(() => {
  const HEADER_SELECTOR = '[data-ck-header]';

  function setVar(name, value) {
    if (!name) return;
    if (value === undefined || value === null || value === '') {
      document.documentElement.style.removeProperty(name);
      return;
    }
    document.documentElement.style.setProperty(name, value);
  }

  function updateBodyAndAssetVars(headerEl) {
    const bodyBgImage = headerEl.getAttribute('data-body-bg-image') || '';
    const bodyBgRepeat = headerEl.getAttribute('data-body-bg-repeat') || 'repeat';
    const cartBgDesktop = headerEl.getAttribute('data-cart-bg-desktop') || '';
    const cartBgMobile = headerEl.getAttribute('data-cart-bg-mobile') || '';
    const logoHeight = headerEl.getAttribute('data-logo-height') || '';
    const logoHeightMobile = headerEl.getAttribute('data-logo-height-mobile') || '';

    setVar('--ck-body-bg-repeat', bodyBgRepeat);
    setVar('--ck-body-bg-image', bodyBgImage ? `url("${bodyBgImage}")` : '');
    setVar('--ck-cart-bg-desktop', cartBgDesktop ? `url("${cartBgDesktop}")` : '');
    setVar('--ck-cart-bg-mobile', cartBgMobile ? `url("${cartBgMobile}")` : '');
    setVar('--ck-logo-height', logoHeight ? `${logoHeight}px` : '');
    setVar('--ck-logo-height-mobile', logoHeightMobile ? `${logoHeightMobile}px` : '');
  }

  function updateHeaderCustomProperties() {
    const headerEl = document.querySelector(HEADER_SELECTOR);
    const headerGroup = document.querySelector('#header-group');
    if (!headerEl || !headerGroup) return;

    const headerHeight = headerEl.offsetHeight;
    let headerGroupHeight = 0;

    const children = headerGroup.children;
    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (!(element instanceof HTMLElement)) continue;
      headerGroupHeight += element.offsetHeight;
    }

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
  }

  function initResizeObserver() {
    if (window.__ckHeaderResizeObserverInitialized) return;
    window.__ckHeaderResizeObserverInitialized = true;

    updateHeaderCustomProperties();

    const headerGroup = document.querySelector('#header-group');
    const headerEl = document.querySelector(HEADER_SELECTOR);
    if (!headerGroup || !headerEl) return;

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(updateHeaderCustomProperties);
      ro.observe(headerGroup);
      ro.observe(headerEl);
      window.__ckHeaderResizeObserver = ro;
      return;
    }

    window.addEventListener('resize', updateHeaderCustomProperties);
  }

  function initHeader(headerEl) {
    if (!headerEl || headerEl.dataset.ckHeaderInit === '1') return;
    headerEl.dataset.ckHeaderInit = '1';

    updateBodyAndAssetVars(headerEl);
    initResizeObserver();

    const innerHeader = headerEl.querySelector('[data-ck-inner-header]');
    const navContainer = headerEl.querySelector('.navContainer');
    const primaryNav = headerEl.querySelector('[data-ck-primary-nav]');
    const menuToggle = headerEl.querySelector('[data-ck-menu-toggle]');
    const searchToggle = headerEl.querySelector('[data-ck-search-toggle]');
    const searchInput = headerEl.querySelector('input[type="search"]');
    const cartTrigger = headerEl.querySelector('[data-ck-cart-trigger]');

    const closeMenu = () => {
      if (!navContainer) return;
      navContainer.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    };

    const openMenu = () => {
      if (!navContainer) return;
      navContainer.classList.add('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    };

    const toggleMenu = () => {
      if (!navContainer) return;
      const isOpen = navContainer.classList.contains('is-open');
      if (isOpen) closeMenu();
      else openMenu();
    };

    if (menuToggle && navContainer && primaryNav) {
      menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        toggleMenu();
      });

      document.addEventListener('click', (e) => {
        if (!(e.target instanceof Node)) return;
        if (!navContainer.classList.contains('is-open')) return;
        const clickedInside = navContainer.contains(e.target) || menuToggle.contains(e.target);
        if (!clickedInside) closeMenu();
      });
    }

    const closeSearch = () => {
      if (!innerHeader) return;
      innerHeader.classList.remove('is-search-open');
    };

    const openSearch = () => {
      if (!innerHeader) return;
      innerHeader.classList.add('is-search-open');
      if (searchInput) {
        window.setTimeout(() => searchInput.focus(), 0);
      }
    };

    const toggleSearch = () => {
      if (!innerHeader) return;
      const isOpen = innerHeader.classList.contains('is-search-open');
      if (isOpen) closeSearch();
      else openSearch();
    };

    if (searchToggle && innerHeader) {
      searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        toggleSearch();
      });

      document.addEventListener('click', (e) => {
        if (!(e.target instanceof Node)) return;
        if (!innerHeader.classList.contains('is-search-open')) return;
        const searchBlock = headerEl.querySelector('.block.block-search');
        const clickedInside =
          searchToggle.contains(e.target) || (searchBlock && searchBlock.contains(e.target));
        if (!clickedInside) closeSearch();
      });
    }

    if (cartTrigger) {
      cartTrigger.addEventListener('click', (e) => {
        const drawer = headerEl.querySelector('cart-drawer-component');
        if (!drawer) return;

        e.preventDefault();
        customElements.whenDefined('cart-drawer-component').then(() => {
          if (typeof drawer.open === 'function') drawer.open();
        });
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeMenu();
      closeSearch();
    });
  }

  function initAll() {
    document.querySelectorAll(HEADER_SELECTOR).forEach(initHeader);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const headerEl = event.target?.querySelector?.(HEADER_SELECTOR);
    if (headerEl) initHeader(headerEl);
  });
})();
